import { AlertTriangle, Database, FileText } from "lucide-react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import type { ProductWorkspace, WorkspaceArtifact, WorkspaceLifecycleItem } from "../types";

export const PROGRESS_LABELS = {
  complete: "已完成",
  active: "进行中",
  blocked: "受阻",
  planned: "待开始",
};

export function WorkspaceNotice({ workspace }: { workspace: ProductWorkspace }) {
  return (
    <div className="workspace-notice" role="status">
      <Database size={16} />
      <strong>{workspace.label}</strong>
      <span>{workspace.read_only ? "版本化只读输入" : "可写输入"}</span>
    </div>
  );
}

export function WorkspaceUnavailable({ reason = "当前轨道未声明产品工作台数据。" }: { reason?: string }) {
  return (
    <div className="workspace-empty" role="status">
      <AlertTriangle size={22} />
      <div><strong>工作台暂不可用</strong><p>{reason}</p></div>
    </div>
  );
}

export function LifecycleRail({ items, selected, onSelect }: {
  items: WorkspaceLifecycleItem[];
  selected: string;
  onSelect: (id: string) => void;
}) {
  if (!items.length) return <WorkspaceUnavailable reason="生命周期输入为空。" />;
  return (
    <div className="lifecycle-scroll" aria-label="产品生命周期">
      <div className="lifecycle-rail">
        {items.map((item) => (
          <button
            type="button"
            key={item.id}
            className={`lifecycle-node state-${item.status} ${selected === item.id ? "is-selected" : ""}`}
            onClick={() => onSelect(item.id)}
            aria-pressed={selected === item.id}
          >
            <span>{String(item.number).padStart(2, "0")}</span>
            <strong>{item.label}</strong>
            <small>{PROGRESS_LABELS[item.status]}</small>
          </button>
        ))}
      </div>
    </div>
  );
}

export function ArtifactViewer({ artifact }: { artifact?: WorkspaceArtifact }) {
  if (!artifact) return <WorkspaceUnavailable reason="所选产物不存在或尚未生成。" />;
  const codeLike = ["diff", "tests", "logs", "json"].includes(artifact.kind);
  return (
    <article className="artifact-viewer">
      <header><FileText size={17} /><div><strong>{artifact.title}</strong><span>{artifact.kind} · {artifact.source_name}</span></div></header>
      {codeLike
        ? <pre><code>{artifact.content}</code></pre>
        : <div className="workspace-markdown"><ReactMarkdown remarkPlugins={[remarkGfm]}>{artifact.content}</ReactMarkdown></div>}
    </article>
  );
}
